import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";

import { AppBar, Box, Dialog, DialogContent, IconButton, Slide, Toolbar, Typography } from '@mui/material';
import SubCategories from './SubCategories';
import SubList from './SubList';
import SpendingDetails from './SpendingDetails';
import SwipeableTabs from '../../container/MUI/SwipeableTabs';
import StackedStats from '../Stats/StackedStats';
import { ArrowBack, Close } from '@mui/icons-material';
import SubCategoriesBudget from './SubCategoriesBudget';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}
class SpendingBySubCategory extends Component {
    state = { 
        openList: false,
        selectedSub: "",
        openSingle: false,
        selectedSpending: {},
     }

    groupBy = (array, prop) => {

		return array.reduce((acc, obj) => {
			if ( obj.spending_status === "VALIDATE" ){
				let key = obj[prop]
	
				if(!acc[key]){
					acc[key] = [];
				}
				acc[key].push(obj);
			}
				return acc;
		}, {});
	}
	sum = (array, prop) => {
		return array.reduce((acc, obj) => {
			if ( obj.spending_status === "VALIDATE" ){
				let key = obj[prop]
	
				if(!acc[key]){
					acc[key] = 0;
				}
				acc[key] += parseFloat(obj.spending_amount);
			}
				return acc;
		}, {});
	}

    calcData = () => {
        const { CATEGORIES, SPENDINGS } = this.props;
		let listSum = this.sum(Object.values(SPENDINGS), "spending_category")
		let listQty = this.groupBy(Object.values(SPENDINGS), "spending_category")
		// console.log('====================================');
		// console.log({listSum, listQty});
		// console.log('====================================');

		let catLabels = Object.keys(listSum).map(catID => {
			let category = CATEGORIES.CHILD[catID]
			return category.category_name
		})
		let payment_data = Object.values(listSum)
		let total = payment_data.reduce((a, b) => a + b)
	
		console.log({
			catLabels, 
			payment_data,
			listSum,
			listQty,
			total,
		});     
				
		return {
			catLabels, 
			payment_data,
			listSum,
			listQty,
			total
		}
    }
    handleCat = (cat) => {
        console.log('====================================');
        console.log("clicked on cat", cat);
        console.log('====================================');
        this.setState({
            selectedSub: cat,
            openList: true,
        })
    }
    handleSingle = (spending) => {
        console.log('====================================');
        console.log("clicked on spending", spending, this.props.SPENDINGSLIST);
        console.log('====================================');
        this.setState({
            selectedSpending: this.props.SPENDINGSLIST[spending],
            openSingle: true,
        })
    }

    render() {
        const { openList, selectedSub, openSingle, selectedSpending  } = this.state;
        const { category, SPENDINGS, SUPPLIERS, BANKS, LABELS, BUDGETS, CATEGORIES, isBudget } = this.props;
        const { PARENT, CHILD, ALL} = this.props.CATEGORIES;
        // console.log('====================================');
        // console.log({ category, SPENDINGS });
        // console.log('====================================');

        let infos = {
			catLabels: [], 
			payment_data: [],
			listSum: {}, // {IDcat: sum}
			listQty: {}, // {IDcat: qtyTransaction}
			total: 0
        }
        
        if(!isEmpty(SPENDINGS) && !isEmpty(CHILD) && !isEmpty(PARENT)){
			infos = this.calcData()
        }
        
        const { listSum, listQty } = infos;

        return (
            <Dialog
                open={true}
                onClose={this.props.handleClose}
                aria-labelledby="form-dialog-title"
                fullScreen
                TransitionComponent={Transition}
                scroll="body"
            >
                <AppBar style={{position: 'relative', backgroundColor: PARENT[category].category_color}} >
                    {!selectedSub &&
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                onClick={this.props.handleClose}
                                aria-label="Close"
                                size="large">
                                <Close />
                            </IconButton>
                            <Typography variant="h6" color="inherit">
                                {PARENT[category].category_name}
                            </Typography>
                        </Toolbar>
                    }
                    {selectedSub &&
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                onClick={()=> this.setState({openList: false, selectedSub: ""})}
                                aria-label="Close"
                                size="large">
                                <ArrowBack />
                            </IconButton>
                            <Typography variant="h6" color="inherit">
                                {PARENT[category].category_name} - {CHILD[selectedSub].category_name}
                            </Typography>
                        </Toolbar>
                    }
                </AppBar>
                <DialogContent>
                    {!isEmpty(SPENDINGS) && !isEmpty(CHILD) && !isEmpty(PARENT) &&
                        <Box>
                            <SwipeableTabs
                                labels={["Statistiques", "Dépenses"]}
                            >
                                <StackedStats 
                                    CATEGORIES={this.props.CATEGORIES.CHILD}
                                    SPENDINGS={this.props.SPENDINGS}
                                    noDateFilter={this.props.noDateFilter}
                                    budget_max={this.props.budget_max}
                                    budget_year={this.props.budget_year}
                                />
                                <Fragment>
                                    {selectedSub &&
                                        <SubList 
                                            CHILD={CHILD} 
                                            SUPPLIERS={SUPPLIERS} 
                                            handleSingle={this.handleSingle} 
                                            category={selectedSub} 
                                            total={listSum[selectedSub]} 
                                            list={listQty[selectedSub]} 
                                            parent_name={PARENT[category].category_name}
                                            handleClose={()=> this.setState({openList: false, selectedSub: ""})}
                                            openFormCustom={()=> this.props.openFormCustom(selectedSub)}

                                        />
                                    }
                                    {!isEmpty(selectedSpending) &&
                                        <SpendingDetails 
                                            supplier={SUPPLIERS[selectedSpending.spending_supplier]} 
                                            category={CHILD[selectedSpending.spending_category]} 
                                            bank={BANKS[selectedSpending.spending_bank]} 
                                            LABELS={LABELS}
                                            spending={selectedSpending} 
                                            fetchSpendingPayments={this.props.fetchSpendingPayments}
                                            view={this.props.view}
                                            handleClose={()=> this.setState({openSingle: false, selectedSpending: {}})}
                                        />
                                    }
                                    {!openList && !openSingle && !isBudget &&
                                        <SubCategories 
                                            {...infos} 
                                            PARENT={PARENT} 
                                            CHILD={CHILD} 
                                            CATEGORIES={CATEGORIES} 
                                            handleCat={this.handleCat} 
                                            category={category} 
                                            handleClose={this.props.handleClose}
                                        />
                                    }
                                    {!openList && !openSingle && isBudget &&
                                        <SubCategoriesBudget
                                            // budget_year ={2021}
                                            budget_year={this.props.budget_year}
                                            {...infos} 
                                            PARENT={PARENT} 
                                            CHILD={CHILD} 
                                            BUDGETS={BUDGETS} 
                                            CATEGORIES={CATEGORIES} 
                                            handleCat={this.handleCat} 
                                            category={category} 
                                            handleClose={this.props.handleClose}
                                            />
                                        }
                                </Fragment>
                                
                            </SwipeableTabs>
                        </Box>
                    }
                </DialogContent>
            </Dialog>
        );
    }
}

export default SpendingBySubCategory;